import InputFieldContainer, { InputFieldContainerProps } from '../common/InputFieldContainer';
import { useMemo, useState } from 'react';
import CallPhoneInput from './CallPhoneInput';
import { useMutationObserver } from '../../hooks/useMutationObserver';

export default function PhoneInputSection(props: InputFieldContainerProps) {
  const callExtension = useMemo(() => {
    return jQueryCourage('.phone-authenticator-enroll__phone-ext');
  }, []);

  const [ showExtension, setShowExtension ] = useState(
    callExtension.length > 0 && callExtension[0]?.style.display !== 'none'
  );

  const mutationObserverArgs = useMemo(() => ({
    filterOptions: { attributeFilter: [ 'style' ] },
    onMutation: (mutation: MutationRecord) => {
      const el = mutation.target as HTMLElement;
      setShowExtension(el.style.display !== 'none');
    },
  }), []);

  useMutationObserver({
    element: callExtension[0],
    ...mutationObserverArgs,
  });

  if (showExtension) {
    return <div><CallPhoneInput inputContainerProps={props} callExtension={callExtension} /></div>;
  }
  return <div><InputFieldContainer {...props} /></div>;
}
